<div class="product-tile">
  <div *ngIf="config.image" class="product-tile__image">
    <img [src]="config.image" alt="">
  </div>

  <div  class="product-tile__label"
        [innerHTML]="config.label | translate | safeHtml">
  </div>

  <div class="product-tile__title">
    {{ config.title | translate }}
  </div>

  <div *ngIf="config.action" class="product-tile__button">
    <button class="btn btn--secondary">
      <a [href]="config.action.url" target="_blank">{{ config.action.label | translate }}</a>
    </button>
  </div>
</div>
